// extracted by mini-css-extract-plugin
export default {"wrapper":"OrganizationsPage_wrapper__blXMS"};